<template>
  <div class="custom-29" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <div class="left">
        <div class="left-content">
          <div class="title">{{ data.title }}</div>
          <div class="person">请查阅你的康复反馈</div>
          <div class="btn" @click="detailFeedback(data)">立即查阅</div>
        </div>
      </div>
      <div class="right">
        <div class="left-img">
          <img src="../../static/IM/eighteen-msg.png" alt="" />
        </div>
      </div>
      <!-- refId为id 查看时需用 -->
    </div>
    <add-feedback-dialog :addFeedbackVisible="addFeedbackVisible" :patientFeedbackTask="patientFeedbackTask"
      :title="addFeedbackTitle" :status="addFeedbackStatus" @addFeedbackClose="addFeedbackClose">
    </add-feedback-dialog>
  </div>
</template>

<script>
import AddFeedbackDialog from "@/views/newPatientmanage/components/TaskList/addFeedbackDialog.vue";
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    color: {
      type: String,
      default: "#333"
    }
  },
  data() {
    return {
      paramData: {},
      addFeedbackVisible: false, // 添加反馈弹框
      addFeedbackTitle: "添加反馈",
      addFeedbackStatus: "add",
      patientFeedbackTask: {}
    };
  },
  components: {
    AddFeedbackDialog
  },
  created() {},
  methods: {
    detailFeedback(item) {
      this.addFeedbackTitle = "及时反馈";
      this.addFeedbackStatus = "detail";
      this.addFeedbackVisible = true;
      this.patientFeedbackTask = item;
    },
    addFeedbackClose() {
      this.addFeedbackVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.custom-29 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;

  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        div {
          color: #666666;
        }
        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
        .person {
          margin: 5px 0;
        }
        .btn {
          width: 62px;
          height: 27px;
          border-radius: 14px;
          border: 1px solid #0cb79f;
          font-size: 12px;
          color: #ffffff;
          background: #0cb79f;
          line-height: 2;
          text-align: center;
          cursor: pointer;
          margin-top: 20px;
        }
      }
    }
    .right {
      .left-img {
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>
